import BigHeartHealth from 'assets/BigHeartHealth.svg?react';
import cn from 'classnames';
import type React from 'react';
import { Button, Col, Icon, Row, Text } from 'ui';

export type TelehealthButtonType = 'primary' | 'secondary' | 'tertiary';

type P = {
  buttonType?: TelehealthButtonType;
  className?: string;
  onClick: () => void;
} & React.ComponentProps<typeof Button>;

const TelehealthButton = ({ buttonType = 'primary', className, onClick, ...rest }: P) => {
  const renderTelehealthButton = () => {
    switch (buttonType) {
      case 'primary':
        return (
          <Button
            {...rest}
            className={cn('telehealth-button--primary', 'telehealth-button', className)}
            icon={<Icon icon="telehealth-line" />}
            onClick={onClick}
            type="primary"
          />
        );
      case 'secondary':
        return (
          <Row justify="space-between">
            <Col>
              <Button
                {...rest}
                block
                className={cn('telehealth-button--primary', 'telehealth-button', className)}
                onClick={onClick}
                type="primary"
              />
            </Col>
            <Col className="telehealth-button__logo-text">
              <Text type="secondary">Provided by</Text>
            </Col>
            <Col>
              <BigHeartHealth className="telehealth-button__logo-image" />
            </Col>
          </Row>
        );
      case 'tertiary':
        return (
          <Button
            {...rest}
            className={cn('telehealth-button', className)}
            icon={<Icon icon="telehealth-line" />}
            onClick={onClick}
          />
        );
    }
  };

  return renderTelehealthButton();
};

export default TelehealthButton;
